export enum WhereClauseContactenator {

    And = 1,
    Or = 2    

}